import React, { Component } from 'react';
import PagePreview from '../page-preview/PagePreview';

class PagePreviewContainer extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      pages: [],
    };
  }

  componentDidMount() {
  }

  render() {
    const { lang } = this.props;
    return (
      <PagePreview lang={lang} />
    );
  }
}

export default PagePreviewContainer;



// WEBPACK FOOTER //
// ./src/components/page-preview-container/PagePreviewContainer.jsx